/**
 * Helper Page
 * 
 * Full-page container for the Agent Chat interface, allowing for a 
 * focused, immersive experience with the AI assistant.
 */
import { AgentChatPage } from '@/components/AgentChat';

export default function Helper() {
  return <AgentChatPage />;
}
